// import React, { useState } from 'react';
// import {
//   CreditCard,
//   Trash2,
//   CheckCircle,
//   X,
//   BadgeDollarSign,
//   UserCheck,
// } from 'lucide-react';
// import toast from 'react-hot-toast';

// const PremiumTab = ({ isDarkMode }) => {
//   const [showModal, setShowModal] = useState(false);
//   const [cards, setCards] = useState([
//     {
//       brand: 'Visa',
//       last4: '1234',
//       exp: '01/26',
//       default: true,
//       expired: false,
//     },
//     {
//       brand: 'Mastercard',
//       last4: '5678',
//       exp: '01/26',
//       default: false,
//       expired: false,
//     },
//     {
//       brand: 'Mastercard',
//       last4: '9999',
//       exp: '01/24',
//       default: false,
//       expired: true,
//     },
//   ]);

//   const [formData, setFormData] = useState({
//     cardNumber: '',
//     expiry: '',
//     cvc: '',
//     zip: '',
//     name: '',
//   });

//   const [error, setError] = useState('');

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const validateAndSubmit = () => {
//     const { cardNumber, expiry, zip, name, cvc } = formData;
//     if (
//       !cardNumber.match(/^\d{16}$/) ||
//       !expiry.match(/^\d{2}\/\d{2}$/) ||
//       !zip.match(/^\d{5}$/) ||
//       !cvc.match(/^\d{3,4}$/) ||
//       name.trim().length < 3
//     ) {
//       toast.error('Please fill out all fields correctly.');
//       return;
//     }

//     const brand = cardNumber.startsWith('4')
//       ? 'Visa'
//       : cardNumber.startsWith('5')
//       ? 'Mastercard'
//       : 'Unknown';
//     const last4 = cardNumber.slice(-4);

//     setCards((prev) => [
//       ...prev,
//       {
//         brand,
//         last4,
//         exp: expiry,
//         default: false,
//         expired: false,
//       },
//     ]);

//     setFormData({ cardNumber: '', expiry: '', cvc: '', zip: '', name: '' });
//     toast.success('Card added successfully!');
//   };

//   const setDefaultCard = (index) => {
//     const updated = cards.map((card, i) => ({ ...card, default: i === index }));
//     setCards(updated);
//   };

//   const deleteCard = (index) => {
//     const updated = cards.filter((_, i) => i !== index);
//     setCards(updated);
//     toast.success('Card removed');
//   };

//   const bgClass = isDarkMode
//     ? 'bg-gray-900 text-gray-200'
//     : 'bg-white text-gray-800';
//   const borderClass = isDarkMode ? 'border-gray-700' : 'border-gray-200';
//   const inputClass = isDarkMode
//     ? 'bg-gray-800 text-gray-100 border-gray-600 placeholder-gray-400'
//     : 'bg-white text-gray-900 border-gray-300 placeholder-gray-500';

//   return (
//     <div>
//       <div
//         className={`overflow-y-auto h-[calc(75vh-100px)] space-y-10 p-6 rounded-lg shadow-md hide-scrollbar ${bgClass}`}
//       >
//         {/* Payment Card Section */}
//         <section>
//           <h2 className="text-md font-semibold flex items-center gap-2 mb-4">
//             <CreditCard size={20} /> Payment Card
//           </h2>

//           <div
//             className={`space-y-4 p-6 rounded-md border ${borderClass} ${bgClass}`}
//           >
//             {/* Responsive Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <input
//                 type="text"
//                 name="cardNumber"
//                 placeholder="Card number"
//                 value={formData.cardNumber}
//                 onChange={handleInputChange}
//                 maxLength={16}
//                 className={`w-full px-4 py-2 rounded-md border ${inputClass}`}
//               />
//               <input
//                 type="text"
//                 name="expiry"
//                 placeholder="MM / YY"
//                 value={formData.expiry}
//                 onChange={handleInputChange}
//                 className={`w-full px-4 py-2 rounded-md border ${inputClass}`}
//               />
//               <input
//                 type="text"
//                 name="cvc"
//                 placeholder="CVC"
//                 value={formData.cvc}
//                 onChange={handleInputChange}
//                 maxLength={4}
//                 className={`w-full px-4 py-2 rounded-md border ${inputClass}`}
//               />
//               <input
//                 type="text"
//                 name="zip"
//                 placeholder="Billing zip code"
//                 value={formData.zip}
//                 onChange={handleInputChange}
//                 maxLength={5}
//                 className={`w-full px-4 py-2 rounded-md border ${inputClass}`}
//               />
//               {/* Full width on all screens */}
//               <div className="sm:col-span-2">
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Name on your card"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-2 rounded-md border ${inputClass}`}
//                 />
//               </div>
//             </div>

//             {/* Error message */}
//             {error && <p className="text-red-500 text-sm">{error}</p>}

//             {/* Buttons - Responsive Flex */}
//             <div className="flex flex-col sm:flex-row gap-3 mt-4">
//               <button
//                 className="bg-brand hover:bg-brand text-white font-normal py-2 px-4 rounded"
//                 onClick={validateAndSubmit}
//               >
//                 Submit Card
//               </button>
//               <button
//                 onClick={() =>
//                   setFormData({
//                     cardNumber: '4242424242424242',
//                     expiry: '12/26',
//                     cvc: '123',
//                     zip: '90210',
//                     name: 'John Doe',
//                   })
//                 }
//                 className={`py-2 px-4 rounded font-normal border ${
//                   isDarkMode
//                     ? 'bg-red-500 text-white hover:bg-brand'
//                     : 'bg-red-500 text-white hover:bg-brand'
//                 }`}
//               >
//                 Prefill Test Card
//               </button>
//               <button
//                 onClick={() => setShowModal(true)}
//                 className={`py-2 px-4 rounded font-normal ${
//                   isDarkMode
//                     ? 'bg-brand text-white hover:bg-brand'
//                     : 'bg-brand text-white hover:bg-brand'
//                 }`}
//               >
//                 Manage Cards
//               </button>
//             </div>
//           </div>
//         </section>

//         {/* Current Subscription */}
//         <section>
//           <h2 className="text-md font-semibold flex items-center gap-2 mb-4">
//             <UserCheck size={20} /> Current Subscription
//           </h2>
//           <div className={`grid grid-cols-1 md:grid-cols-3 gap-4`}>
//             {[
//               { label: 'PLAN', value: 'Free', action: 'Change' },
//               { label: 'SEATS', value: '1 / 1', action: 'Edit' },
//               {
//                 label: 'NEXT RENEWAL',
//                 value: 'Mar 1, 2024',
//                 note: 'You will receive a refill.',
//               },
//             ].map((item, i) => (
//               <div key={i} className={`p-4 rounded-md border ${borderClass}`}>
//                 <p className="text-sm text-gray-500">{item.label}</p>
//                 <p className="font-medium">{item.value}</p>
//                 {item.action && (
//                   <button className="text-blue-600 hover:underline text-sm mt-1">
//                     {item.action}
//                   </button>
//                 )}
//                 {item.note && (
//                   <p className="text-xs text-gray-500">{item.note}</p>
//                 )}
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* Billing History */}
//         <section>
//           <h2 className="text-md font-semibold flex items-center gap-2 mb-4">
//             <BadgeDollarSign size={20} /> Billing History
//           </h2>

//           {/* Responsive Table Wrapper */}
//           <div className={`overflow-hidden rounded-md border ${borderClass}`}>
//             {/* Desktop Table */}
//             <div className="hidden md:block overflow-x-auto">
//               <table className="min-w-full text-sm">
//                 <thead
//                   className={`${
//                     isDarkMode
//                       ? 'bg-gray-700 text-gray-300'
//                       : 'bg-gray-100 text-gray-600'
//                   }`}
//                 >
//                   <tr>
//                     <th className="px-4 py-2 text-left">Description</th>
//                     <th className="px-4 py-2 text-left">Amount</th>
//                     <th className="px-4 py-2 text-left">Status</th>
//                     <th className="px-4 py-2 text-left">Date</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-300">
//                   {[
//                     {
//                       desc: 'Pro Plan - March',
//                       amount: '$20.00',
//                       date: 'Mar 1, 2024',
//                     },
//                     {
//                       desc: 'Pro Plan - February',
//                       amount: '$20.00',
//                       date: 'Feb 1, 2024',
//                     },
//                   ].map((row, idx) => (
//                     <tr key={idx} className={isDarkMode ? 'text-gray-100' : ''}>
//                       <td className="px-4 py-2">{row.desc}</td>
//                       <td className="px-4 py-2">{row.amount}</td>
//                       <td className="px-4 py-2 text-green-600 flex items-center gap-1">
//                         <CheckCircle size={16} /> Paid
//                       </td>
//                       <td className="px-4 py-2">{row.date}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Mobile Cards */}
//             <div className="md:hidden space-y-4 p-4">
//               {[
//                 {
//                   desc: 'Pro Plan - March',
//                   amount: '$20.00',
//                   date: 'Mar 1, 2024',
//                 },
//                 {
//                   desc: 'Pro Plan - February',
//                   amount: '$20.00',
//                   date: 'Feb 1, 2024',
//                 },
//               ].map((row, idx) => (
//                 <div
//                   key={idx}
//                   className={`rounded-md p-4 border ${
//                     isDarkMode
//                       ? 'border-gray-600 bg-gray-700 text-white'
//                       : 'bg-white border-gray-200 text-gray-800'
//                   }`}
//                 >
//                   <p className="text-sm font-semibold">{row.desc}</p>
//                   <p className="text-sm">Amount: {row.amount}</p>
//                   <p className="text-sm flex items-center gap-1 text-green-600">
//                     <CheckCircle size={14} /> Paid
//                   </p>
//                   <p className="text-sm">Date: {row.date}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </div>

//       {showModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-2">
//           <div
//             className={`w-full max-w-2xl mx-auto p-4 sm:p-6 rounded-lg shadow-lg relative ${
//               isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
//             }`}
//           >
//             {/* Close Button */}
//             <button
//               onClick={() => setShowModal(false)}
//               className={`absolute top-3 right-3 sm:top-4 sm:right-4 ${
//                 isDarkMode
//                   ? 'text-gray-300 hover:text-white'
//                   : 'text-gray-600 hover:text-gray-800'
//               }`}
//             >
//               <X size={20} />
//             </button>

//             {/* Modal Title */}
//             <h3 className="text-md font-semibold mb-1 sm:mb-2">
//               Manage Credit Cards
//             </h3>
//             <p className="text-sm text-gray-500 mb-4">
//               Set default or remove saved cards.
//             </p>

//             {/* Card List */}
//             <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-1 sm:pr-2">
//               {cards.map((card, index) => (
//                 <div
//                   key={index}
//                   className={`flex flex-col sm:flex-row sm:justify-between sm:items-center border rounded-lg p-4 gap-3 ${borderClass}`}
//                 >
//                   {/* Card Info */}
//                   <div className="flex items-center gap-4">
//                     <img
//                       src={
//                         card.brand === 'Visa'
//                           ? 'https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png'
//                           : 'https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png'
//                       }
//                       alt={card.brand}
//                       className="h-6 object-contain"
//                     />
//                     <div>
//                       <p className="font-medium">
//                         {card.brand} ending in {card.last4}
//                       </p>
//                       <p className="text-sm text-gray-500">
//                         Exp. Date {card.exp}
//                       </p>
//                     </div>
//                   </div>

//                   {/* Actions */}
//                   <div className="flex flex-wrap items-center gap-3 sm:gap-4">
//                     {card.default ? (
//                       <span className="bg-green-600 text-white text-xs px-2 py-1 rounded-full flex items-center gap-1">
//                         <CheckCircle size={14} /> Default
//                       </span>
//                     ) : card.expired ? (
//                       <span className="bg-red-100 text-red-600 text-xs px-2 py-1 rounded-full">
//                         Expired
//                       </span>
//                     ) : (
//                       <button
//                         onClick={() => setDefaultCard(index)}
//                         className="text-blue-600 hover:underline text-sm"
//                       >
//                         Set as Default
//                       </button>
//                     )}
//                     <button
//                       onClick={() => deleteCard(index)}
//                       className="text-red-600 hover:text-red-800"
//                       aria-label="Remove card"
//                     >
//                       <Trash2 size={18} />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PremiumTab;
import React, { useState, useEffect } from 'react';
import { CheckCircle, X, BadgeDollarSign, UserCheck } from 'lucide-react';
import toast from 'react-hot-toast';
import {
  getSubscription,
  getOrders,
  pauseSubscription,
  resumeSubscription,
  cancelSubscription,
} from '../../api/api';
import { motion, AnimatePresence } from 'framer-motion';

// 🔄 Loader Spinner
import Loader2 from '../Loader/Loader2';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMeThunk } from '../../redux/slices/authSlice';
import { fetchUserStatistics } from '../../redux/slices/userStatisticsSlice';
import { handleApiError } from '../../helpers/handleApiError';

const PremiumTab = ({ isDarkMode }) => {
  const [subscription, setSubscription] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const bgClass = isDarkMode
    ? 'bg-gray-700 text-white'
    : 'bg-white text-gray-800';
  const borderClass = isDarkMode ? 'border-white' : 'border-gray-200';

  useEffect(() => {
    const fetchBillingData = async () => {
      setLoading(true);
      try {
        const subData = await getSubscription();
        setSubscription(subData.subscription);

        const ordersData = await getOrders();
        setOrders(ordersData.orders);
      } catch (error) {
        handleApiError(error, 'Unable to load billing information');
      }
      setLoading(false);
    };

    fetchBillingData();
  }, []);
  useEffect(() => {
    if (showConfirmModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [showConfirmModal]);

  return (
    <>
      <div className={`space-y-10 p-6 ${bgClass}`}>
        {/* ✅ Subscription Section */}
        <section>
          <h2 className="text-md font-semibold flex items-center gap-2 mb-4">
            <UserCheck size={20} /> Current Subscription
          </h2>
          {loading ? (
            <Loader2 />
          ) : subscription ? (
            <div
              className="
  grid
  grid-cols-1        /* mobile */
  sm:grid-cols-2     /* small screens */
  lg:grid-cols-3     /* tablets / small desktops */
  xl:grid-cols-5     /* large desktops */
  gap-4
"
            >
              {/* Plan */}
              <div className={`p-4 rounded-md border ${borderClass}`}>
                <p className="text-xs sm:text-sm text-gray-500 font-semibold">
                  PLAN
                </p>
                <p className="font-medium mt-1 text-sm sm:text-base">
                  {subscription?.package_name || 'N/A'}
                </p>
              </div>

              {/* Status */}
              <div className={`p-4 rounded-md border ${borderClass}`}>
                <p className="text-xs sm:text-sm text-gray-500 font-semibold">
                  STATUS
                </p>

                {subscription.status === 'active' ? (
                  <span className="flex items-center gap-2 text-green-600 font-medium mt-1 text-sm sm:text-base">
                    <CheckCircle size={16} /> Active
                  </span>
                ) : subscription.status === 'paused' ? (
                  <span className="flex items-center gap-2 text-yellow-500 font-medium mt-1 text-sm sm:text-base">
                    <X size={16} /> Paused
                  </span>
                ) : (
                  <span className="flex items-center gap-2 text-red-600 font-medium mt-1 text-sm sm:text-base">
                    <X size={16} /> {subscription.status || 'Inactive'}
                  </span>
                )}
              </div>

              {/* Start Date */}
              <div className={`p-4 rounded-md border ${borderClass}`}>
                <p className="text-xs sm:text-sm text-gray-500 font-semibold">
                  START DATE
                </p>
                <p className="font-medium mt-1 text-sm sm:text-base">
                  {subscription.start_date
                    ? new Date(subscription.start_date).toLocaleDateString()
                    : 'N/A'}
                </p>
              </div>

              {/* End Date */}
              <div className={`p-4 rounded-md border ${borderClass}`}>
                <p className="text-xs sm:text-sm text-gray-500 font-semibold">
                  END DATE
                </p>
                <p className="font-medium mt-1 text-sm sm:text-base">
                  {subscription.end_date
                    ? new Date(subscription.end_date).toLocaleDateString()
                    : 'N/A'}
                </p>
              </div>

              {/* Next Renewal */}
              <div className={`p-4 rounded-md border ${borderClass}`}>
                <p className="text-xs sm:text-sm text-gray-500 font-semibold">
                  NEXT RENEWAL
                </p>
                <p className="font-medium mt-1 text-sm sm:text-base">
                  {subscription.next_renewal_date
                    ? new Date(
                        subscription.next_renewal_date
                      ).toLocaleDateString()
                    : subscription.end_date
                    ? new Date(subscription.end_date).toLocaleDateString()
                    : 'N/A'}
                </p>
              </div>
            </div>
          ) : (
            <p>No active subscription</p>
          )}
        </section>

        <AnimatePresence>
          {!loading &&
            subscription &&
            (subscription.status === 'active' ||
              subscription.status === 'paused') &&
            subscription?.package_name.toLowerCase() !== 'free' && (
              <motion.div
                key="subscription-actions"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{ duration: 0.3 }}
                className="mt-5 flex flex-wrap sm:flex-nowrap items-center gap-4"
              >
                {/* Pause / Resume */}
                <button
                  onClick={() => {
                    setActionType(
                      subscription.status === 'paused' ? 'resume' : 'pause'
                    );
                    setShowConfirmModal(true);
                  }}
                  className={`px-5 py-2.5 text-sm sm:text-base rounded-md font-semibold transition-all shadow-sm ${
                    subscription.status === 'paused'
                      ? 'bg-green-600 hover:bg-green-700 text-white'
                      : 'bg-gradient-to-r from-yellow-600 to-yellow-700 hover:opacity-90 disabled:opacity-70 text-white'
                  }`}
                >
                  {subscription.status === 'paused'
                    ? 'Resume Subscription'
                    : 'Pause Subscription'}
                </button>

                {/* Cancel Subscription */}
                <button
                  onClick={() => {
                    setActionType('cancel');
                    setShowConfirmModal(true);
                  }}
                  className="px-5 py-2.5 text-sm sm:text-base rounded-md font-semibold bg-red-600 hover:bg-red-700 text-white shadow-sm transition-all"
                >
                  Cancel Subscription
                </button>
              </motion.div>
            )}
        </AnimatePresence>

        {/* ✅ Billing History Section */}
        <section>
          <h2 className="text-md font-semibold flex items-center gap-2 mb-4">
            <BadgeDollarSign size={20} /> Billing History
          </h2>

          {loading ? (
            <Loader2 />
          ) : orders?.length === 0 ? (
            <p>No billing history available</p>
          ) : (
            <div className={`overflow-hidden rounded-md border ${borderClass}`}>
              <div className=" overflow-x-auto">
                <table className="min-w-full text-sm">
                  <thead
                    className={`${
                      isDarkMode
                        ? 'bg-gray-700 text-white'
                        : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    <tr>
                      <th className="px-4 py-2 text-left">Package</th>
                      <th className="px-4 py-2 text-left">Cycle</th>
                      <th className="px-4 py-2 text-left">Amount</th>
                      <th className="px-4 py-2 text-left">Payment Method</th>
                      <th className="px-4 py-2 text-left">Status</th>
                    </tr>
                  </thead>
                  <tbody
                    className={`divide-y ${
                      isDarkMode ? 'divide-gray-600' : 'divide-gray-300'
                    }`}
                  >
                    {Array.isArray(orders) &&
                      orders.map((row, idx) => (
                        <tr
                          key={idx}
                          className={isDarkMode ? 'text-gray-100' : ''}
                        >
                          <td className="px-4 py-2">
                            {row.package_name || row.Package?.name}
                          </td>
                          <td className="px-4 py-2 capitalize">
                            {row.billing_cycle}
                          </td>
                          <td className="px-4 py-2">
                            {row.currency} ${row.amount}
                          </td>
                          <td className="px-4 py-2 capitalize">
                            {row.payment_method}
                          </td>
                          <td className="px-4 py-2">
                            {row.status === 'paid' ? (
                              <span className="flex items-center gap-1 text-green-600">
                                <CheckCircle size={16} /> Paid
                              </span>
                            ) : (
                              <span className="flex items-center gap-1 text-red-600">
                                <X size={16} /> {row.status}
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </section>
      </div>
      <AnimatePresence>
        {showConfirmModal && (
          <motion.div
            key="subscription-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.3, ease: 'easeOut' }}
              className={`rounded-2xl shadow-2xl w-full max-w-sm sm:p-8 p-5 transition-all ${
                isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
              }`}
            >
              <h2 className="text-lg sm:text-xl font-bold mb-3 tracking-tight text-center">
                {actionType === 'pause'
                  ? 'Pause Subscription'
                  : actionType === 'resume'
                  ? 'Resume Subscription'
                  : 'Cancel Subscription'}
              </h2>

              <p
                className={`text-sm mb-6 text-center ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-600'
                }`}
              >
                {actionType === 'pause'
                  ? 'Are you sure you want to pause your subscription? You will not be charged until you resume.'
                  : actionType === 'resume'
                  ? 'Are you sure you want to resume your subscription? Billing will resume as per your plan.'
                  : 'Are you sure you want to cancel your subscription? Your access will end after the current billing cycle.'}
              </p>

              <div className="flex flex-col sm:flex-row gap-3">
                {/* Cancel Button */}
                <button
                  onClick={() => !actionLoading && setShowConfirmModal(false)}
                  disabled={actionLoading}
                  className={`w-full py-2.5 px-4 rounded-lg font-semibold transition-colors ${
                    isDarkMode
                      ? 'bg-gray-700 hover:bg-gray-600 text-white disabled:opacity-50'
                      : 'bg-gray-800 hover:bg-gray-900 text-white disabled:opacity-50'
                  }`}
                >
                  Close
                </button>

                {/* Action Button */}
                <button
                  disabled={actionLoading}
                  onClick={async () => {
                    setActionLoading(true);
                    try {
                      let res;
                      if (actionType === 'pause') {
                        res = await pauseSubscription(
                          subscription.subscription_id
                        );
                      } else if (actionType === 'resume') {
                        res = await resumeSubscription(
                          subscription.subscription_id
                        );
                      } else if (actionType === 'cancel') {
                        res = await cancelSubscription(
                          subscription.subscription_id
                        );
                      }

                      toast.success(
                        res.message ||
                          (actionType === 'pause'
                            ? 'Subscription paused successfully.'
                            : actionType === 'resume'
                            ? 'Subscription resumed successfully.'
                            : 'Subscription cancelled successfully.')
                      );

                      setShowConfirmModal(false);
                      const subData = await getSubscription();
                      setSubscription(subData.subscription);
                      await dispatch(fetchUserStatistics(user?.id));
                      await dispatch(fetchMeThunk());
                    } catch (error) {
                      toast.error(
                        error.message || 'Failed to update subscription.'
                      );
                    } finally {
                      setActionLoading(false);
                    }
                  }}
                  className={`w-full py-2.5 px-4 rounded-lg text-white font-semibold shadow-sm transition-all flex items-center justify-center gap-2
      ${
        actionType === 'pause'
          ? 'bg-gradient-to-r from-yellow-600 to-yellow-700 hover:opacity-90 disabled:opacity-70'
          : actionType === 'resume'
          ? 'bg-gradient-to-r from-green-600 to-green-700 hover:opacity-90 disabled:opacity-70'
          : 'bg-gradient-to-r from-red-600 to-red-700 hover:opacity-90 disabled:opacity-70'
      }`}
                >
                  {actionLoading ? (
                    <>
                      <svg
                        className="animate-spin h-4 w-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        ></path>
                      </svg>
                      {actionType === 'pause'
                        ? 'Pausing...'
                        : actionType === 'resume'
                        ? 'Resuming...'
                        : 'Cancelling...'}
                    </>
                  ) : actionType === 'pause' ? (
                    'Pause'
                  ) : actionType === 'resume' ? (
                    'Resume'
                  ) : (
                    'Cancel'
                  )}
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default PremiumTab;
